"use client";
import { FC } from "react";

import IconMiniLogo from "@/components/UI/Icon/IconMiniLogo/IconMiniLogo";
import { useCartContext } from "@/providers/CartContextProvider";
import * as Dialog from "@radix-ui/react-dialog";
import styles from "./CartBusyOverlay.module.scss";

const CartBusyOverlay: FC = () => {
	const { isModifyingCart } = useCartContext();

	return (
		<Dialog.Root open={isModifyingCart}>
			<Dialog.Portal>
				<Dialog.Overlay className={styles.overlay} />
				<Dialog.Content className={styles.content}>
					<IconMiniLogo />
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
};

export default CartBusyOverlay;
